<template>
  <v-layout column>
    <v-flex>
      <RecordList :records="records" />
    </v-flex>

    <v-flex class="mt-2">
      <v-layout justify-center align-center>
        <v-btn
          v-if="count < recordCount"
          flat
          color="primary"
          @click="loadMore"
        >
          Load More
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import RecordList from "@/components/RecordList";

export default {
  props: ["project"],
  components: {
    RecordList
  },
  watch: {
    "$route.params.projectId": function() {
      this.init();
    }
  },
  computed: {
    ...mapState(["recordReader"]),
    recordCount() {
      if (this.project !== undefined) return this.project.totalCount;
      return 0;
    },
    projectId() {
      return this.$route.params.projectId;
    }
  },
  async mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.count = 8;
      await this.getRecord();
    },
    async loadMore() {
      this.count += 8;
      await this.getRecord();
    },
    async getRecord() {
      let result = await this.recordReader.getRecordsByProjectId(
        this.projectId,
        this.count
      );
      this.records = result;
    }
  },
  data() {
    return {
      records: [],
      count: 8
    };
  }
};
</script>
